import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../app-environments/environment';

export class ServiceBase {
  private static _url: string;

  public static get baseHref(): string {
    return ServiceBase._url;
  }

  public static set baseHref(value: string) {
    if (!value) {
      ServiceBase._url = '';
    } else {
      ServiceBase._url = (!value.endsWith('/')) ? value : value.substr(0, value.length - 1);
    }
  }

  static handleError(err: HttpErrorResponse, errorCb?: ((a: HttpErrorResponse) => void)) {
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
      if (errorCb) {
        errorCb(err);
      }
    }
  }

  static sanitize(inp: any): any {
    if (!inp) {
      return null;
    } else {
      const o: any = {};
      for (const property in inp) {
        if (typeof (inp[property]) === 'string') {
          if (!property.toLowerCase().includes('password') && inp.hasOwnProperty(property)) {
            o[property] = ServiceBase.sanitizeString(inp[property] as string);
          }
        } else if (typeof (inp[property]) === 'object') {
          o[property] = ServiceBase.sanitize(inp[property]);
        } else if (typeof (inp[property]) === 'boolean') {
          if (inp.hasOwnProperty(property)) {
            o[property] = inp[property];
          }
        } else if (typeof (inp[property]) !== 'function') {
          if (inp.hasOwnProperty(property) && inp[property]) {
            o[property] = inp[property];
          }
        }
      }
      return o;
    }
  }

  static sanitizeString(inp: string): string {
    if (!inp) {
      return null;
    } else {
      for (const prop in environment.sanitizeMap) {
        if (environment.sanitizeMap.hasOwnProperty(prop)) {
          inp = inp.replace(new RegExp(prop, 'g'), environment.sanitizeMap[prop]);
        }
      }
      return inp.trim();
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/services/service-base.ts